/**
 * @file Header.
 */

import { gsap } from 'gsap';

/**
 * Header component.
 */
const mHeader = () => {
	const header = document.querySelector('.m-header');

	if (!header) {
		return;
	}

	const searchTrigger = header.querySelector('.m-header__search-trigger');
	const searchBar     = header.querySelector('.m-header__search-bar');
	const searchClose   = searchBar.querySelector('.m-header__search-close');
	const menuQuery     = window.matchMedia('(max-width: 1200px)');
	const menuTrigger   = header.querySelector('.m-header__menu-trigger');
	const mobileMenu    = header.querySelector('.m-header__mobile-menu');
	const menuInner     = mobileMenu.querySelector('.m-header__menu-inner');
	const pgTriggers    = mobileMenu.querySelectorAll('.menu-item-has-children > a');
	const ddTriggers    = header.querySelectorAll('.m-header__nav-list .menu-item-has-children > a');
	let animating       = false;

	searchTrigger.addEventListener('click', () => {
		gsap.to(searchBar, {
			duration:   0.3,
			y:          0,
			ease:       'sine.out',
			onComplete: () => {
				searchBar.classList.add('visible');
				searchBar.removeAttribute('style');
				searchBar.querySelector('input').focus();
			},
		});
	});

	searchClose.addEventListener('click', () => {
		gsap.to(searchBar, {
			duration:   0.3,
			y:          -100,
			ease:       'sine.out',
			onComplete: () => {
				searchBar.classList.remove('visible');
				searchBar.removeAttribute('style');
			},
		});
	});

	/**
	 * Open menu.
	 *
	 */
	const menuOpen = () => {
		if (animating) {
			return;
		}

		// const headerHeight = header.querySelector('.m-header__inner').getBoundingClientRect().height;

		gsap.timeline({
			onStart: () => {
				animating = true;
				document.querySelector('body').classList.add('menu-open');
			},
			onComplete: () => {
				animating = false;
				menuTrigger.setAttribute('aria-expanded', 'true');
			},
			defaults: {
				duration: 0.3,
				ease:     'sine.out',
			},
		})
			.to(mobileMenu, {
				y:          0,
				onComplete: () => {
					mobileMenu.classList.add('open');
					mobileMenu.removeAttribute('style');
				},
			})
			.to(menuInner, {
				opacity: 1,
			}, '-=0.3');
	};

	/**
	 * Close menu.
	 *
	 */
	const menuClose = () => {
		if (animating) {
			return;
		}

		gsap.timeline({
			onStart: () => {
				animating = true;
				document.querySelector('body').classList.remove('menu-open');
			},
			onComplete: () => {
				[...pgTriggers].forEach((trigger) => {
					const pg = trigger.parentElement.querySelector('.m-header__menu-sublist');
					pg.setAttribute('inert', '');
					trigger.setAttribute('aria-expanded', 'false');
				});

				animating = false;
				menuTrigger.setAttribute('aria-expanded', 'false');
			},
			defaults: {
				duration: 0.45,
				ease:     'sine.out',
			},
		})
			.to(menuInner, {
				opacity: 0,
			})
			.to(mobileMenu, {
				y:          '-100%',
				onComplete: () => {
					mobileMenu.classList.remove('open');
					mobileMenu.removeAttribute('style');
				},
			}, '-=0.3');
	};

	/**
	 * Toggle menu.
	 *
	 */
	const menuToggle = () => {
		if (menuTrigger.getAttribute('aria-expanded') === 'true') {
			menuClose();
		} else {
			menuOpen();
		}
	};

	menuTrigger.addEventListener('click', () => {
		if (menuQuery.matches) {
			menuToggle();
		}
	});

	[...pgTriggers].forEach((trigger) => {
		const pg = trigger.parentElement.querySelector('.m-header__menu-sublist');
		const back = pg.querySelector('.m-header__menu-subitem-back');

		trigger.addEventListener('click', (e) => {
			e.preventDefault();

			if (!menuQuery.matches) {
				return;
			}

			pg.removeAttribute('inert');
			trigger.setAttribute('aria-expanded', 'true');
			pg.focus();
		});

		back.addEventListener('click', (e) => {
			e.preventDefault();

			if (!menuQuery.matches) {
				return;
			}

			pg.setAttribute('inert', '');
			trigger.setAttribute('aria-expanded', 'false');
			trigger.focus();
		});
	});

	[...ddTriggers].forEach((trigger) => {
		const { parentElement } = trigger;
		const dd = parentElement.querySelector('.m-header__nav-sublist');

		trigger.addEventListener('click', (e) => {
			e.preventDefault();

			if (menuQuery.matches) {
				return;
			}

			const open = parentElement.getAttribute('aria-expanded') === 'true';

			if (!open) {
				// determine hz position
				const { left } = parentElement.getBoundingClientRect();
				dd.style.display = 'flex';
				const { right, width } = dd.getBoundingClientRect();
				dd.removeAttribute('style');

				if (left + width > window.innerWidth) {
					dd.style.setProperty('--sublist-translate-x', `calc(-50% - 1.75rem + ${window.innerWidth - right}px)`);
				}
			}

			dd.toggleAttribute('inert');
			parentElement.setAttribute('aria-expanded', !open);

			if (!open) {
				dd.focus();
			} else {
				dd.removeAttribute('style');
				trigger.focus();
			}
		});
	});
};

export default mHeader;
